// import React, { useState } from 'react';
// import emailjs from '@emailjs/browser';


// const Contact = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     contactNumber: '',
//     email: '',
//     feedbackMessage: ''
//   });

//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [message, setMessage] = useState('');
//   const [messageType, setMessageType] = useState('');

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//     if (message) {
//       setMessage('');
//       setMessageType('');
//     }
//   };

//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();

//   //   if (!formData.name || !formData.contactNumber || !formData.email || !formData.feedbackMessage) {
//   //     setMessage('Please fill in all fields');
//   //     setMessageType('error');
//   //     return;
//   //   }

//   //   setIsSubmitting(true);
//   //   setMessage('');

//   //   try {
//   //     const backendResponse = await fetch('http://localhost:5006/api/contact', {
//   //       method: 'POST',
//   //       headers: {
//   //         'Content-Type': 'application/json'
//   //       },
//   //       body: JSON.stringify(formData)
//   //     });

//   //     if (!backendResponse.ok) {
//   //       throw new Error('Failed to save contact to backend');
//   //     }

//   //     console.log('✅ Data saved to backend');
//   //     setMessage('Thank you! Your message has been submitted successfully.');
//   //     setMessageType('success');

//   //     // Clear the form
//   //     setFormData({
//   //       name: '',
//   //       contactNumber: '',
//   //       email: '',
//   //       feedbackMessage: ''
//   //     });

//   //   } catch (error) {
//   //     console.error('❌ Error saving to backend:', error);
//   //     setMessage('Failed to save your message. Try again.');
//   //     setMessageType('error');
//   //   } finally {
//   //     setIsSubmitting(false);
//   //   }
//   // };

//   const handleSubmit = (e) => {
//     e.preventDefault();
  
//     if (!formData.name || !formData.contactNumber || !formData.email || !formData.feedbackMessage) {
//       setMessage('Please fill in all fields');
//       setMessageType('error');
//       return;
//     }
  
//     setIsSubmitting(true);
  
//     emailjs.send(
//       'YOUR_SERVICE_ID',
//       'contact_template',
//       formData,
//       'YOUR_PUBLIC_KEY'
//     )
//     .then(() => {
//       setMessage('✅ Message sent successfully!');
//       setMessageType('success');
  
//       setFormData({
//         name: '',
//         contactNumber: '',
//         email: '',
//         feedbackMessage: ''
//       });
//     })
//     .catch(() => {
//       setMessage('❌ Failed to send message');
//       setMessageType('error');
//     })
//     .finally(() => {
//       setIsSubmitting(false);
//     });
//   };

//   return (
//     <>
//       <section className="contact-section">
//         <div className="form-container">
//           <h2>Contact Us</h2>
//           {message && (
//             <div className={`alert ${messageType === 'success' ? 'alert-success' : 'alert-error'}`}>
//               {message}
//             </div>
//             )}
//           <form className="contact-form" onSubmit={handleSubmit}>
//             <label htmlFor="name">Name</label>
//             <input
//               type="text"
//               id="name"
//               name="name"
//               value={formData.name}
//               onChange={handleInputChange}
//               placeholder="Full name"
//               required
//             />

//             <label htmlFor="contactNumber">Contact Number</label>
//             <input
//               type="tel"
//               id="contactNumber"
//               name="contactNumber"
//               value={formData.contactNumber}
//               onChange={handleInputChange}
//               placeholder="+91 98765 4321"
//               required
//             />
//              <label htmlFor="email">Email</label>
//       <input
//         type="email"
//         id="email"
//         name="email"
//         value={formData.email}
//         onChange={handleInputChange}
//         placeholder="you@example.com"
//         required
//       />

//             <label htmlFor="feedbackMessage"> Message</label>
//             <textarea
//               id="feedbackMessage"
//               name="feedbackMessage"
//               value={formData.feedbackMessage}
//               onChange={handleInputChange}
//               placeholder="Write your message here..."
//               required
//             ></textarea>

//             <button type="submit" disabled={isSubmitting}>
//               {isSubmitting ? 'Submitting...' : 'SUBMIT'}
//             </button>
//           </form>
//         </div>
//       </section>

//        <section className="contact-info-section">
//         <div className="contact-info">
//            <div className="info-item">
//       <img src="/images/Email.png" alt="email icon" />
//       <span>amanchikankari17@gmail.com</span>
//     </div>
//     <div className="info-item">
//       <img src="/images/Phone.png" alt="phone icon" />
//       <span>+91-73920-20965</span>
//     </div>
//     <div className="info-item">
//       <img src="/images/Spacer Icon Wrapper.png" alt="location icon" />
//       <span>12, Tulsi Theatre, Hazratganj, 226001</span>
//     </div>
//         </div>
// <div className="bottom-decoration-wrapper">
//         <img src="images/Vector3.png" alt="left decoration" className="bottom-left-img" />
//         <img src="images/Vector4.png" alt="right decoration" className="bottom-right-img" />
         
//         </div>
//       </section>

      
//     </>
//   );
// };

// export default Contact;




import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    contactNumber: '',
    email: '',
    feedbackMessage: '',
    bot_field: '' // 🛡️ spam protection
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [toast, setToast] = useState({
    show: false,
    type: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // 🚀 UPDATED SUBMIT
  const handleSubmit = (e) => {
    e.preventDefault();

    // 🛡️ Honeypot spam check
    if (formData.bot_field) {
      console.log("Bot detected");
      return;
    }

    if (!formData.name || !formData.contactNumber || !formData.email || !formData.feedbackMessage) {
      setToast({
        show: true,
        type: 'error',
        message: 'Please fill all fields'
      });
      return;
    }

    setIsSubmitting(true);

    emailjs.send(
      'YOUR_SERVICE_ID',
      'contact_template',
      formData,
      'YOUR_PUBLIC_KEY'
    )
    .then(() => {
      setToast({
        show: true,
        type: 'success',
        message: '✅ Message sent successfully!'
      });

      setFormData({
        name: '',
        contactNumber: '',
        email: '',
        feedbackMessage: '',
        bot_field: ''
      });
    })
    .catch(() => {
      setToast({
        show: true,
        type: 'error',
        message: '❌ Failed to send message'
      });
    })
    .finally(() => {
      setIsSubmitting(false);

      setTimeout(() => {
        setToast({ show: false, type: '', message: '' });
      }, 3000);
    });
  };

  return (
    <>
      <section className="contact-section">
        <div className="form-container">
          <h2>Contact Us</h2>

          {/* 🔥 TOAST */}
          {toast.show && (
            <div className={`toast ${toast.type}`}>
              {toast.message}
            </div>
          )}

          <form className="contact-form" onSubmit={handleSubmit}>

            {/* 🛡️ Hidden spam field */}
            <input
              type="text"
              name="bot_field"
              value={formData.bot_field}
              onChange={handleInputChange}
              style={{ display: 'none' }}
            />

            <label htmlFor="name">Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Full name"
              required
            />

            <label htmlFor="contactNumber">Contact Number</label>
            <input
              type="tel"
              name="contactNumber"
              value={formData.contactNumber}
              onChange={handleInputChange}
              placeholder="+91 98765 4321"
              required
            />

            <label htmlFor="email">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="you@example.com"
              required
            />

            <label htmlFor="feedbackMessage">Message</label>
            <textarea
              name="feedbackMessage"
              value={formData.feedbackMessage}
              onChange={handleInputChange}
              placeholder="Write your message here..."
              required
            ></textarea>

            {/* 🚀 BUTTON */}
            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? <span className="loader"></span> : 'SUBMIT'}
            </button>

          </form>
        </div>
      </section>

      <section className="contact-info-section">
        <div className="contact-info">
          <div className="info-item">
            <img src="/images/Email.png" alt="email icon" />
            <span>amanchikan17@gmail.com</span>
          </div>
          <div className="info-item">
            <img src="/images/Phone.png" alt="phone icon" />
            <span>+91-73920-20965</span>
          </div>
          <div className="info-item">
            <img src="/images/Spacer Icon Wrapper.png" alt="location icon" />
            <span>12, Tulsi Theatre, Hazratganj, 226001</span>
          </div>
        </div>

        <div className="bottom-decoration-wrapper">
          <img src="images/Vector3.png" alt="left decoration" className="bottom-left-img" />
          <img src="images/Vector4.png" alt="right decoration" className="bottom-right-img" />
        </div>
      </section>
    </>
  );
};

export default Contact;
